import React, { useEffect, useState } from "react";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../Images/no-data-found.webp";
import BottomMenu from "../../../layout/bottomMenu";
import Calculator from "../../../DistanceCalculator/Calculator";
import MeetingRating from "../../../Rating/Rating";
import { toast } from "react-toastify";
import {emailDropdownData} from "../../../../service/Dealer/action";
const UserRatingList = ({
                          match,
                          getLeadFilter,
                          leadFilter,
                          history,
                          getjuniorListingForHod,
                          juniorListHod = [],
                          saveRatingForHod,
                          ratingByHod = [],
                          checkStarForRating,
                          getStarCheck = [],
                          emailDropdownData,
                          email=[]
                        }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [open, setOpen] = useState(false);
  const [isFilterRemove, setIsRemoveFilter] = useState(false);
  const [pageNo, setPage] = useState(1);
  const [userId, setUserId] = useState("");
  const [openRatingModel, setOpenRatingModel] = useState(false);
  const [checkStar, setCheckStart] = useState(0);
  const [starId, setStarId] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      let filter = window.localStorage.hod_filter ? JSON.parse(window.localStorage.hod_filter) : [{}];
      await getjuniorListingForHod(1, filter);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await checkStarForRating(userId);
      await emailDropdownData()
      setIsLoading(false);
    })();
  }, []);

  const handleFilter = async (key, value, stringValue = "") => {
    const list = [...filterInputList];
    list[0][key] = value;
    setFilterInputList(list);
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    let filter = window.localStorage.hod_filter ? JSON.parse(window.localStorage.hod_filter) : [{}];
    await getjuniorListingForHod(val?.selected + 1, filter);
    setIsLoading(false);
  };

  useEffect(() => {
    if (
        ratingByHod?.status_code &&
        parseInt(ratingByHod?.status_code) === 200
    ) {
      toast.success("Rating is marked successfully");

      (async () => {
        setOpenRatingModel(false);
        setIsLoading(true);
        // await activityList('lead', match?.params?.id)
        setIsLoading(false);
      })();
    } else if (
        ratingByHod?.status_code &&
        parseInt(ratingByHod?.status_code) !== 200
    ) {
      toast.warning(ratingByHod?.message);
      setOpenRatingModel(false);
    }
  }, [ratingByHod]);

  const handleSubmitFilter = async () => {
    setOpen(false);
    setIsLoading(true);
    localStorage.setItem('hod_filter', JSON.stringify(filterInputList))
    await getjuniorListingForHod(1, filterInputList);
    setIsLoading(false);
  };

  const handleRemoveFilter = async (key) => {
    if (key !== "") {
      delete filterInputList[0][key];
      setFilterInputList(filterInputList);
      setIsLoading(true);
      if(filterInputList[0].length === 0){
        delete window.localStorage.hod_filter
      } else {
        window.localStorage.hod_filter = JSON.stringify(filterInputList)
      }
      await getjuniorListingForHod(localStorage.getItem(1), filterInputList);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (isFilterRemove) {
        setFilterInputList([{}]);
        setIsLoading(true);
        await getjuniorListingForHod(localStorage.getItem(1), filterInputList);
        setIsLoading(false);
        setIsRemoveFilter(false);
      }
    })();
  }, [isFilterRemove]);

  function isCurrentMonth(date) {
    const currentDate = new Date();
    const givenDate = new Date(date);
    return currentDate.getMonth() === givenDate.getMonth() && currentDate.getFullYear() === givenDate.getFullYear();
  }



  return (
      <>
        <Loader isLoading={isLoading} />
        <div id="wrapper">
          <DashboardMenu />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <Header title={"Rating"} history={history} />
              <div className="container-fluid common-bg">
                {/*Heading*/}
                <div className="container-fluid bootstrap snippets bg-white">
                  {openRatingModel ? (
                          <div className="popup-box">
                            <div className="box">
                              <MeetingRating
                                  id={userId}
                                  ratingSave={saveRatingForHod}
                                  loadApi={getjuniorListingForHod}
                                  setOpenRatingModel={setOpenRatingModel}
                                  type={"HOD"}
                              />
                            </div>
                          </div>
                      ) :
                      <>
                        <div className="d-sm-flex align-items-center justify-content-between">
                          <div className="row col-md-12">

                            <button
                                onClick={() => setOpen(!open)}
                                className="btn btn-sm btn-primary mr-1 btn-filter"
                                type="button"
                            >
                              <i className="fa fa-filter lh-35 pd-3"></i>
                            </button>
                          </div>
                        </div>

                        {/* Filter View */}
                        {filterInputList[0] !== undefined &&
                            Object.keys(filterInputList[0]).length > 0 && (
                                <div className="d-sm-flex align-items-center justify-content-between mb-5">
                                  <div className="row pd-filter-div">
                                    <div className="col-md-12 col-sm-12 d-flex">
                                      <div className="applied-filter">
                                        {Object.keys(filterInputList[0]).map((val, i) => {
                                          return (
                                              <>
                                  <span className="fd-1">
                                    <span
                                        style={{ textTransform: "capitalize" }}
                                    >
                                      {val.replaceAll("_", " ")}
                                    </span>
                                    {" - " + filterInputList[0][val]}
                                    <i
                                        className="bi bi-x-circle"
                                        onClick={(e) => {
                                          handleRemoveFilter(val);
                                        }
                                        }
                                    ></i>
                                  </span>
                                              </>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            )}
                        {/* Filter View End*/}

                        <div className="col-md-12 col-sm-12 mt-5">
                          <div className="card shadow mb-4">
                            <div className="card-body">
                              <h4 className="small font-weight-bold text-black-100">
                                <b>Fulfillment %</b>
                                <span className="float-right">
                          {juniorListHod?.fulfillment}%
                        </span>
                              </h4>
                              <div className="progress mb-4">
                                {juniorListHod?.fulfillment !== undefined &&
                                    juniorListHod?.fulfillment < 15 && (
                                        <div
                                            className="progress-bar bg-danger"
                                            role="progressbar"
                                            style={{
                                              width: `${juniorListHod?.fulfillment}%`,
                                            }}
                                            aria-valuenow="20"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        ></div>
                                    )}

                                {juniorListHod?.fulfillment &&
                                    juniorListHod?.fulfillment > 15 &&
                                    juniorListHod?.fulfillment < 40 && (
                                        <div
                                            className="progress-bar bg-warning"
                                            role="progressbar"
                                            style={{
                                              width: `${juniorListHod?.fulfillment}%`,
                                            }}
                                            aria-valuenow="20"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        ></div>
                                    )}
                                {juniorListHod?.fulfillment &&
                                    juniorListHod?.fulfillment > 40 && (
                                        <div
                                            className="progress-bar bg-success"
                                            role="progressbar"
                                            style={{
                                              width: `${juniorListHod?.fulfillment}%`,
                                            }}
                                            aria-valuenow="20"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        ></div>
                                    )}
                              </div>
                              <div className="d-flex">
                                <div className="sl text-center">
                                  <span className=""><b>Total sub-ordinates</b></span>
                                    <span>{juniorListHod?.sm_count}</span>
                                </div>
                                <div className="sl text-center ">
                                  <span className="cgs"></span>
                                </div>
                                <div className="sl text-center">
                                  <span><b>Pending sub-ordinates to be rated</b></span>
                                    <span>{juniorListHod?.pending_sm}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          {/*CARD START*/}
                          {juniorListHod &&
                              juniorListHod?.sm_details !== undefined &&
                              juniorListHod?.sm_details?.data?.map((val, i) => {
                                return (
                                    <>
                                      <div className="col-md-4 col-sm-6">
                                        <div className="card-big-shadow">
                                          <div
                                              className="card card-just-text"
                                              data-background=""
                                              data-color=""
                                              data-radius="none"
                                          >
                                            <div className="content">
                                              <h6 className="category mrg-b-12">
                                                <div className="row">
                                                  <div
                                                      className="col-10"
                                                      style={{
                                                        color: "#000",
                                                        fontSize: "20px",
                                                        textAlign: "left",
                                                        paddingLeft: "20px",
                                                      }}
                                                  >
                                                    <span className="">{val?.name}</span>
                                                  </div>
                                                  <div className="col md-2">
                                        <span>
                                          <a href={`/sm-view/${val?.id}`}>
                                            <i className="bi bi-eye" style={{fontSize: "20px"}}/>
                                          </a>
                                        </span>
                                                  </div>
                                                </div>
                                                <div className="row list-view mt-4">

                                                  <div className="mb-flex">
                                                    <div className="col-md-4">
                                                      <i
                                                          className="fa fa-envelope"
                                                          style={{ color: "#970f0f" }}
                                                          aria-hidden="true"
                                                      ></i>
                                                      &nbsp;&nbsp;Email:
                                                    </div>
                                                    {val?.email !== null && (
                                                        <div className="col-md-8">
                                              <span
                                                  className="trigger"
                                                  data-tooltip-id="1"
                                                  title={val?.email}
                                                  style={{float:"right", "marginRight":"23px"}}
                                              >
                                                {val?.email}
                                              </span>
                                                        </div>
                                                    )}
                                                  </div>


                                                  <div className="mb-flex mt-2">
                                                    <div className="col-md-6 col-sm-6">
                                                      <i
                                                          className="fa fa-business-time"
                                                          style={{ color: "blue" }}
                                                          aria-hidden="true"
                                                      ></i>
                                                      &nbsp;&nbsp;No. of meeting done(last
                                                      month):
                                                    </div>
                                                    {val?.meeting_count !== null && (
                                                        <div className="col-md-6 col-sm-6 l2">
                                              <span
                                                  className="trigger"
                                                  data-tooltip-id="1"
                                                  title={val?.meeting_count}
                                                  style={{float:"right", "marginRight":"23px"}}
                                              >
                                                {val?.meeting_count}
                                              </span>
                                                        </div>
                                                    )}
                                                  </div>


                                                  <div className="mb-flex mt-2">
                                                    <div className="col-md-6 col-sm-6">
                                                      <i
                                                          className="fa fa-table"
                                                          style={{ color: "green" }}
                                                          aria-hidden="true"
                                                      ></i>
                                                      &nbsp;&nbsp;No. of meeting rated by
                                                      RM:
                                                    </div>
                                                    <div className="col-md-6 col-sm-6 l2">
                                                    {val?.rated_count !== null && (

                                                          <span
                                                              className="trigger"
                                                              data-tooltip-id="1"
                                                              title={val?.rated_count}
                                                              style={{float:"right", "marginRight":"23px"}}
                                                          >
                                                            {val?.rated_count}
                                                          </span>

                                                    )}
                                                    </div>
                                                  </div>


                                                  <div className="mb-flex mt-2">
                                                    <div className="col-md-6 col-sm-6">
                                                      <i
                                                          className="fa fa-envelope"
                                                          style={{ color: "#c98349" }}
                                                          aria-hidden="true"
                                                      ></i>
                                                      &nbsp;&nbsp;Avg. score:
                                                    </div>
                                                    <div className="col-md-6 col-sm-6 l2">
                                                      {val?.average_rating !== null && (

                                                          <span
                                                              className="trigger"
                                                              data-tooltip-id="1"
                                                              title={parseFloat(val?.average_rating).toFixed(2)}
                                                              style={{float:"right", "marginRight":"23px"}}
                                                          >
                                                {parseFloat(val?.average_rating).toFixed(2)}
                                              </span>

                                                      )}
                                                    </div>
                                                  </div>


                                                  <div className="mb-flex mt-2">
                                                    <div className="col-md-6 col-sm-6">
                                                      <i
                                                          className="fa fa-star"
                                                          style={{ color: "#c98349" }}
                                                          aria-hidden="true"
                                                      ></i>
                                                      &nbsp;&nbsp;HOD last month rating:
                                                    </div>
                                                    <div className="col-md-6 col-sm-6 l2">
                                                      {val?.hod_rating !== null && (

                                                          <span
                                                              className="trigger"
                                                              data-tooltip-id="1"
                                                              title={val?.hod_rating}
                                                              style={{float:"right", "marginRight":"23px"}}
                                                          >
                                                              {val?.hod_rating}
                                                            </span>

                                                      )}
                                                    </div>
                                                  </div>

                                                  <div className="mb-flex mt-2">
                                                    <div className="col-md-6 col-sm-6">
                                                      <i
                                                          className="fas fa-thumbtack"
                                                          style={{ color: "#c2a60d" }}
                                                          aria-hidden="true"
                                                      ></i>
                                                      &nbsp;&nbsp;HOD feedback:
                                                    </div>
                                                    <div className="col-md-6 col-sm-6 l2">
                                                      {val?.hod_feedback !== null && (

                                                          <span
                                                              className="trigger"
                                                              data-tooltip-id="1"
                                                              title={val?.hod_feedback}
                                                              style={{float:"right", "marginRight":"23px"}}
                                                          >
                                                            {val?.hod_feedback}
                                                          </span>
                                                      )}
                                                    </div>

                                                  </div>

                                                  {val?.user_rating_date && val?.rated_by_name !== null && (
                                                      <div className="mb-flex mt-2">
                                                        <div className="col-md-6 col-sm-6">
                                                          <i
                                                              className="fa fa-male"
                                                              style={{ color: "black" }}
                                                              aria-hidden="true"
                                                          ></i>
                                                          &nbsp;&nbsp;Rated by:
                                                        </div>

                                                        <div className="col-md-6 col-sm-6 l2">
                                                          <span
                                                              className="trigger"
                                                              data-tooltip-id="1"
                                                              title={val?.rated_by_name}
                                                              style={{float:"right", "marginRight":"23px"}}
                                                          >
                                                            {val?.rated_by_name}
                                                          </span>
                                                        </div>
                                                      </div>
                                                  )}

                                                  {val?.user_rating_date && val?.rated_by_email !== null && (
                                                      <div className="mb-flex mt-2">
                                                        <div className="col-md-6 col-sm-6">
                                                          <i
                                                              className="fa fa-envelope"
                                                              style={{ color: "#c98349" }}
                                                              aria-hidden="true"
                                                          ></i>
                                                          &nbsp;&nbsp;Rated by email:
                                                        </div>

                                                        <div className="col-md-6 col-sm-6 l2">
                                                          <span
                                                              className="trigger"
                                                              data-tooltip-id="1"
                                                              title={val?.rated_by_email}
                                                              style={{float:"right", "marginRight":"23px"}}
                                                          >
                                                            {val?.rated_by_email}
                                                          </span>
                                                        </div>
                                                      </div>
                                                  )}

                                                  {val?.user_rating_date !== null && val?.rating_date !== null && (
                                                      <div className="mb-flex mt-2">
                                                        <div className="col-md-6 col-sm-6">
                                                          <i
                                                              className="fa fa-calendar"
                                                              style={{ color: "#c98349" }}
                                                              aria-hidden="true"
                                                          ></i>
                                                          &nbsp;&nbsp;Rating date:
                                                        </div>

                                                        <div className="col-md-6 col-sm-6 l2">
                                                          <span
                                                              className="trigger"
                                                              data-tooltip-id="1"
                                                              title={val?.rating_date}
                                                              style={{float:"right", "marginRight":"23px"}}
                                                          >
                                                            {val?.rating_date}
                                                          </span>
                                                        </div>
                                                      </div>
                                                  )}

                                                </div>
                                                <hr />
                                              </h6>
                                            </div>
                                            {val?.user_rating_date == null  && !isCurrentMonth(val.user_rating_date) && (
                                                <div className="row list-view-links mb-4">
                                                  <ul>
                                                    <li>
                                                      <a
                                                          style={{ color: "black" }}
                                                          onClick={() => {
                                                            setOpenRatingModel(true);
                                                            setUserId(val?.id);
                                                          }}
                                                      >
                                                        <i
                                                            className="fa fa-star"
                                                            style={{ color: "gold" }}
                                                            aria-hidden="true"
                                                        ></i>
                                                        &nbsp;&nbsp;Rate
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                            )}

                                          </div>
                                        </div>
                                      </div>
                                    </>
                                );
                              })}
                          {juniorListHod &&
                              juniorListHod?.sm_details !== undefined &&
                              juniorListHod?.sm_details?.data.length > 0 && (
                                  <div className="panel-pagination-col panel-table-pagination">
                                    <ReactPaginate
                                        previousLabel={"<"}
                                        nextLabel={">"}
                                        breakLabel={"..."}
                                        breakClassName={"break-me"}
                                        pageCount={
                                            juniorListHod?.sm_details?.total /
                                            juniorListHod?.sm_details?.per_page
                                        }
                                        forcePage={
                                            juniorListHod?.sm_details?.current_page - 1
                                        }
                                        pageRangeDisplayed={4}
                                        onPageChange={onPageChange}
                                        activeClassName={"active"}
                                    />
                                  </div>
                              )}
                          {juniorListHod &&
                              juniorListHod?.sm_details !== undefined &&
                              juniorListHod?.sm_details?.data?.length === 0 && (
                                  <>
                                    <img
                                        src={NotFoundData}
                                        className="not-found-data"
                                        alt={""}
                                    />
                                    <div className="text-center" style={{ width: "100%" }}>
                                      Data Not Found
                                    </div>

                                  </>
                              )}
                        </div>
                      </>
                  }

                </div>
              </div>
            </div>
          </div>

          <BottomMenu
              open={open}
              setOpen={setOpen}
              handleSubmitFilter={handleSubmitFilter}
              filterContent={{data:[
                  {
                    'field': 'dropdown',
                    'place_holder': 'Month',
                    'values': [
                      {'id': 1, 'name': 'Jan'},
                      {'id': 2, 'name': 'Feb'},
                      {'id': 3, 'name': 'Mar'},
                      {'id': 4, 'name': 'Apr'},
                      {'id': 5, 'name': 'May'},
                      {'id': 6, 'name': 'Jun'},
                      {'id': 7, 'name': 'Jul'},
                      {'id': 8, 'name': 'Aug'},
                      {'id': 9, 'name': 'Sep'},
                      {'id': 10, 'name': 'Oct'},
                      {'id': 11, 'name': 'Nov'},
                      {'id': 12, 'name': 'Dec'}
                    ]
                  },

                  {'field' :'dropdown', 'place_holder' : 'Email', 'values' : email},
                  {'field' : 'dropdown', 'place_holder' : 'Rating', 'values' : [{'id' : 1, 'name' : '1'}, {'id' : 2, 'name' : '2'}, {'id' : 3, 'name' : '3'},  {'id' : 4, 'name' : '4'},  {'id' : 5, 'name' : '5'}]},
                ]}}
              handleFilter={handleFilter}
              setIsRemoveFilter={setIsRemoveFilter}
              localstorageKeyRemove={"hod_filter"}
          />

        </div>
        {/* section ends */}
      </>
  );
};

export default UserRatingList;
